"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ApplicationLayoutBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debounce = _interopRequireDefault(require("lodash/fp/debounce"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "innerClassName", "forceScrollbar", "enableScrollToTop", "banner", "navigation", "bottomBar", "bottomBarHeight", "children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var RESIZE_THROTTELING = 200;
var ApplicationLayoutBody = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    innerClassName = props.innerClassName,
    forceScrollbar = props.forceScrollbar,
    enableScrollToTop = props.enableScrollToTop,
    banner = props.banner,
    navigation = props.navigation,
    bottomBar = props.bottomBar,
    bottomBarHeight = props.bottomBarHeight,
    children = props.children,
    remainigProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    offset = _useState2[0],
    setOffset = _useState2[1];
  var moduleContentRef = (0, _react.useRef)();
  var layoutBodyRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return layoutBodyRef;
  }, []);
  (0, _react.useEffect)(function () {
    if (layoutBodyRef.current) {
      layoutBodyRef.current.parentNode.style = "--ApplicationLayoutBodyBottomBarHeight: ".concat(bottomBarHeight, "px");
    }
  }, [bottomBarHeight]);
  var handleScroll = (0, _debounce["default"])(RESIZE_THROTTELING)(function () {
    if (moduleContentRef.current) {
      setOffset(moduleContentRef.current.scrollTop);
    }
  });
  var handleToTop = function handleToTop() {
    if (!moduleContentRef.current) {
      return;
    }
    var currentScroll = moduleContentRef.current.scrollTop;
    if (currentScroll > 0) {
      window.requestAnimationFrame(handleToTop);
      moduleContentRef.current.scrollTo(0, currentScroll - currentScroll / 5);
      setOffset(currentScroll);
    }
  };
  var classes = (0, _classnames["default"])('ApplicationLayoutBody', bottomBar && 'has-footer', className);
  var innerClasses = (0, _classnames["default"])('module-content', forceScrollbar && 'overflow-y-scroll', innerClassName && innerClassName);
  var offsetThreshold = window.innerHeight * 0.1;
  var scrollToTopClasses = (0, _classnames["default"])('scroll-to-top', offset > offsetThreshold && 'in');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, remainigProps, {
    ref: layoutBodyRef,
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "module-content-wrapper"
  }, navigation && navigation, banner && banner, /*#__PURE__*/_react["default"].createElement("div", {
    className: innerClasses,
    onScroll: handleScroll,
    ref: moduleContentRef
  }, children)), enableScrollToTop && /*#__PURE__*/_react["default"].createElement("span", {
    className: scrollToTopClasses
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary btn-icon-only",
    onClick: handleToTop
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph rioglyph-arrow-up"
  })))), bottomBar && bottomBar);
});
exports.ApplicationLayoutBody = ApplicationLayoutBody;
ApplicationLayoutBody.defaultProps = {
  className: '',
  enableScrollToTop: true,
  forceScrollbar: false,
  bottomBarHeight: 54
};
ApplicationLayoutBody.propTypes = {
  className: _propTypes["default"].string,
  enableScrollToTop: _propTypes["default"].bool,
  forceScrollbar: _propTypes["default"].bool,
  innerClassName: _propTypes["default"].string,
  banner: _propTypes["default"].node,
  navigation: _propTypes["default"].node,
  bottomBar: _propTypes["default"].node,
  bottomBarHeight: _propTypes["default"].number
};
var _default = ApplicationLayoutBody;
exports["default"] = _default;